import { getNamedType, isInputObjectType } from 'graphql';
import analyzeFilterInputType from './analyzeFilterInputType.js';

const getFilterArgCandidates = ({ targetField, leafFieldNames, preferredArgName }) => {
  if (!targetField?.args?.length) {
    return [];
  }

  return targetField.args
    .map((argument) => {
      const inputType = getNamedType(argument.type);

      if (!isInputObjectType(inputType)) {
        return null;
      }

      const analysis = analyzeFilterInputType({ inputType, leafFieldNames });
      const matchedFieldCount = analysis.fieldOperators.size;
      const operatorCount = [...analysis.fieldOperators.values()].reduce((count, operators) => count + operators.size, 0);
      const score = (argument.name === preferredArgName ? 100 : 0) + (['where', 'filter'].includes(argument.name) ? 80 : 0) + matchedFieldCount * 10 + operatorCount;

      return {
        analysis,
        argument,
        inputType,
        matchedFieldCount,
        operatorCount,
        score
      };
    })
    .filter(Boolean)
    .filter((candidate) => candidate.matchedFieldCount > 0 || candidate.argument.name === preferredArgName || ['where', 'filter'].includes(candidate.argument.name))
    .sort((a, b) => b.score - a.score);
};

export default getFilterArgCandidates;
